import clsx from 'clsx'
import type { FunctionComponent, KeyboardEventHandler } from 'react'
import useWindowDimensions from '../../../hooks/useWindowDimensions'
import { CustomTooltip } from '../shared/CustomTooltip'
import style from './Form.module.sass'

type UnitInputProps = {
	label?: string
	tooltip?: string
	placeholder?: string
	unit?: string
	name: string
	tooltipText?: string
	buttonLabel?: string
	defaultValue?: string | number | undefined
	value?: number
	onChange?: React.ChangeEventHandler<HTMLInputElement>
	buttonContent?: React.ReactNode
	disabled?: boolean
	min?: number
}

export const UnitInput: FunctionComponent<UnitInputProps> = ({
	label,
	tooltip,
	tooltipText,
	placeholder,
	unit,
	name,
	buttonLabel,
	value,
	buttonContent,
	min,
	onChange,
	disabled = false,
}) => {
	const inputHandler: KeyboardEventHandler<HTMLInputElement> = (event) => {
		if (String(event.currentTarget.value).length >= 4) {
			event.preventDefault()
			return
		}
	}

	const { width } = useWindowDimensions()
	const isMobile = Number(width) <= 768

	return (
		<div className={clsx(style.unitInputWrapper, buttonLabel && style.unitInputWrapperWide)}>
			<label className={clsx(style.unitInputLabelWrapper, disabled && style.unitInputLabelWrapperIsDisabled)}>
				<div className={style.unitInputbody}>
					<h2 className={style.unitInputLabel}>{label}</h2>
				</div>
				<div className={clsx(style.fieldWrapper, disabled && style.fieldWrapperIsDisabled)}>
					<input
						type="number"
						name={name}
						disabled={disabled}
						value={value}
						min={min ?? 0}
						className={clsx(style.input, style.unitInput)}
						placeholder={placeholder}
						onKeyPress={inputHandler}
						onChange={onChange}
						inputMode="numeric"
					/>
					<div className={style.unit}>{unit}</div>
				</div>
				{buttonContent}
			</label>
			{tooltip && label && (
				<>
					<span
						className={clsx(style.tooltip, style.tooltipUnit)}
						data-tooltip-id={isMobile ? `${name}Mobile` : name}
						data-tip
					>
						{tooltip} <span className={style.tooltipIcon}>?</span>
					</span>
					<CustomTooltip
						tooltipId={isMobile ? `${name}Mobile` : name}
						textAfterHover={<div className={style.unitTooltip}>{tooltipText}</div>}
					/>
				</>
			)}
		</div>
	)
}
